import * as React from 'react';

import { cn } from '@/helpers/ui-utils';

type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * A neutral placeholder block for content that's still loading; size and shape
 * it with `className`. It's decorative and hidden from assistive technology, so
 * whatever renders it is responsible for announcing the loading state.
 */
export default function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'rounded bg-neutral-200 motion-safe:animate-pulse',
        className,
      )}
      {...props}
    />
  );
}
